import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';
import {
  Grid,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  TableHead,
  Checkbox,
} from '@material-ui/core';
import DateInput from '../../../atoms/Calendar/DateInput';
import ColorPicker from '../ColorPicker';
import { useTranslation } from 'react-i18next';
import { XYDeviceSelectItem, XYItemSelectItem, XY_CMP_GROUP_SET } from '../../../../function/GroupDataModel';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import { TableBaseStyle } from './XYCompansonSettingSytle';

type XYDateSettingsProps = {
  selectData: XY_CMP_GROUP_SET;
  onChangeSelectDataEvent: (xyGroupSetData: XY_CMP_GROUP_SET) => void;
}

/**
 * 月選択用リスト
 * @returns 
 */
const getMonthList = (): ComboBoxItemType[] => {

  let monthList: ComboBoxItemType[] = [];

  for (let i = 0; i <= 12; i++) {
    let item: ComboBoxItemType = {
      index: i,
      name: i === 0 ? '' : `${i}`,
      tag: ''
    };
    monthList.push(item)
  }

  return monthList;
}

const XYDateSettings: React.FC<XYDateSettingsProps> = (props: XYDateSettingsProps) => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();
  const [changeEventFlg, setChangeEventFlg] = useState(false);
  const [selectData, setSelectData] = useState<XY_CMP_GROUP_SET>(props.selectData)

  /**
   * 選択グループデータ取得
   */
  useEffect(() => {
    const groupData = props.selectData && props.selectData ? props.selectData : null;
    if (groupData) {
      setSelectData(groupData);
    }
    console.debug(['XYDateSettingsProps', props.selectData])
  }, [props.selectData]);

  /**
   * 変更処理
   */
  useEffect(() => {
    console.debug(['XYDateSettings onChangeEvent', selectData])
    props.onChangeSelectDataEvent(selectData);
    setChangeEventFlg(false)
  }, [changeEventFlg]);

  /**
   * 変更イベント
   */
  const changeEvent = () => {
    setChangeEventFlg(true)
  }

  /**
   * 月設定項目
   */
  const monthCol = (
    <>
      <TableCell className={classes.headerCell} width={'50px'}>
        {t('XYComparisonSetting.色', '色')}
      </TableCell>
      <TableCell className={classes.headerCell} width={'200px'}>
        {t('XYComparisonSetting.開始月', '開始月')}
      </TableCell>
      <TableCell className={classes.headerCell} width={'200px'}>
        {t('XYComparisonSetting.終了月', '終了月')}
      </TableCell>
    </>
  )

  return (
    <Table className={classes.gridStyle2}>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2} className={classes.headerCell} width={'80px'}>
            {t('XYDateSettings.表示', '表示')}
          </TableCell>
          <TableCell colSpan={2} className={classes.headerCell} width={'480px'}>
            {t('XYDateSettings.年設定', '年設定')}
          </TableCell>
          <TableCell colSpan={3} className={classes.headerCell} width={'300px'}>
            {t('XYDateSettings.月設定1', '月設定1')}
          </TableCell>
          <TableCell colSpan={3} className={classes.headerCell} width={'300px'}>
            {t('XYDateSettings.月設定2', '月設定2')}
          </TableCell>
          <TableCell colSpan={3} className={classes.headerCell} width={'300px'}>
            {t('XYDateSettings.月設定3', '月設定3')}
          </TableCell>
          <TableCell colSpan={3} className={classes.headerCell} width={'300px'}>
            {t('XYDateSettings.月設定4', '月設定4')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.headerCell} width={'40px'}>{t('XYDateSettings.年設定', '年設定')}</TableCell>
          <TableCell className={classes.headerCell} width={'40px'}>{t('XYDateSettings.月設定', '月設定')}</TableCell>
          <TableCell className={classes.headerCell} width={'240px'}>{t('XYDateSettings.開始日', '開始日')}</TableCell>
          <TableCell className={classes.headerCell} width={'240px'}>{t('XYDateSettings.終了日', '終了日')}</TableCell>
          {monthCol}
          {monthCol}
          {monthCol}
          {monthCol}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {/**年設定 */}
          <TableCell className={classes.bodyCellCenter} width={'80px'}>
            <Checkbox
              checked={selectData.YEAR_FLG === 1}
              onChange={(e) => {
                const newYearFlg = e.target.checked ? 1 : 0;
                setSelectData((prevData) => ({ ...prevData, YEAR_FLG: newYearFlg }));
                changeEvent()
              }}
            />
          </TableCell>
          {/**月設定 */}
          <TableCell className={classes.bodyCellCenter} width={'60px'}>
            <Checkbox
              checked={selectData.MONTH_FLG == 1}
              onChange={(e) => {
                const newMonthFlg = e.target.checked ? 1 : 0;
                setSelectData((prevData) => ({ ...prevData, MONTH_FLG: newMonthFlg }));
                changeEvent();
              }}
            />
          </TableCell>
          {/**年設定 開始日 */}
          <TableCell className={classes.bodyCellCenter} width={'160px'}>
            <DateInput
              //labelCssString={classes.labelStyle}
              initialValue={selectData.START_DATE}
              label={'from'}
              labelPosition={0}
              onDateChange={(e) => {
                setSelectData((prevData) => ({ ...prevData, START_DATE: e }))
                changeEvent();
              }}
            ></DateInput>
          </TableCell>
          {/**年設定 終了日 */}
          <TableCell className={classes.bodyCellCenter} width={'160px'}>
            <DateInput
              //labelCssString={classes.labelStyle}
              initialValue={selectData.END_DATE}
              label={'from'}
              labelPosition={0}
              onDateChange={(e) => {
                setSelectData((prevData) => ({ ...prevData, END_DATE: e }))
                changeEvent();
              }}
            ></DateInput>
          </TableCell>
          {/**月設定1 色 */}
          <TableCell className={classes.bodyCellCenterColor} width={'60px'}>
            <ColorPicker
              color={selectData.DSP_COLOR1}
              setColor={(col) => {
                setSelectData((prevData) => ({ ...prevData, DSP_COLOR1: col }));
                changeEvent()
              }}
            />
          </TableCell>
          {/**月設定1 開始月 */}
          <TableCell className={classes.bodyCellCenter} width={'120px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.START_MONTH1 === null ? 0 : selectData.START_MONTH1}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, START_MONTH1: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定1 終了月 */}
          <TableCell className={classes.bodyCellCenter} width={'120px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.END_MONTH1 === null ? 0 : selectData.END_MONTH1}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, END_MONTH1: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定2 色 */}
          <TableCell className={classes.bodyCellCenterColor} width={'40px'}>
            <ColorPicker
              color={selectData.DSP_COLOR2}
              setColor={(col) => {
                setSelectData((prevData) => ({ ...prevData, DSP_COLOR2: col }));
                changeEvent();
              }}
            />
          </TableCell>
          {/**月設定2 開始月 */}
          <TableCell className={classes.bodyCellCenter} width={'40px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.START_MONTH2 === null ? 0 : selectData.START_MONTH2}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, START_MONTH2: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定2 終了月 */}
          <TableCell className={classes.bodyCellCenter} width={'40px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.END_MONTH2 === null ? 0 : selectData.END_MONTH2}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, END_MONTH2: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定3 色 */}
          <TableCell className={classes.bodyCellCenterColor} width={'40px'}>
            <ColorPicker
              color={selectData.DSP_COLOR3}
              setColor={(col) => {
                setSelectData((prevData) => ({ ...prevData, DSP_COLOR3: col }));
                changeEvent();
              }}
            />
          </TableCell>
          {/**月設定3 開始月 */}
          <TableCell className={classes.bodyCellCenter} width={'40px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.START_MONTH3 === null ? 0 : selectData.START_MONTH3}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, START_MONTH3: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定3 終了月 */}
          <TableCell className={classes.bodyCellCenter} width={'40px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.END_MONTH3 === null ? 0 : selectData.END_MONTH3}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, END_MONTH3: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定4 色 */}
          <TableCell className={classes.bodyCellCenterColor} width={'40px'}>
            <ColorPicker
              color={selectData.DSP_COLOR4}
              setColor={(col) => {
                setSelectData((prevData) => ({ ...prevData, DSP_COLOR4: col }));
                changeEvent();
              }}
            />
          </TableCell>
          {/**月設定4 開始月 */}
          <TableCell className={classes.bodyCellCenter} width={'40px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.START_MONTH4 === null ? 0 : selectData.START_MONTH4}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, START_MONTH4: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
          {/**月設定4 終了月 */}
          <TableCell className={classes.bodyCellCenter} width={'40px'}>
            <ItemComboBox
              itemList={getMonthList()}
              label=""
              value={selectData.END_MONTH4 === null ? 0 : selectData.END_MONTH4}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  setSelectData((prevData) => ({ ...prevData, END_MONTH4: Number(e.target.value) }));
                  changeEvent();
                }
              }}
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default XYDateSettings;